import React, { useState, Fragment, useEffect } from 'react'
import {
  Form,
  Input,
  Button,
  Select,
  message,
  DatePicker,
  Row,
  Col,
  Modal,
  AutoComplete,
  Card,
  Table,
  Pagination,
} from 'antd'
import {
  JobService,
  HomeService,
  TechnicainService,
  JobGroupService,
  ProjectService,
  PersonnelService,
  InformfixService,
} from '../../../services'
import {
  Moment,
  disabledDateTime,
  openNotificationWithIcon,
} from '../../../helpers'

import './style.scss'
import { observer, inject } from 'mobx-react'
import { InformfixStatus } from '../../informfix/InformfixStatus'
import { SearchOutlined } from '@ant-design/icons'
const TextArea = Input.TextArea
const { Option } = Select

@inject('informStore')
@observer
class JobForm extends React.Component {
  constructor(props) {
    super()
    this.state = {
      homes: [],
      home: {},
      homeSelected: null,
      projects: [],
      loadingProject: false,
      loadingHome: false,
      loading: false,
      jobId: null,
      job: {},
      currentTime: '',
      errors: {},
      listJobStatus: [],
      technicians: [],
      techniciansTemp: [],
      selectedResponsible: [],
      selectedTechnician: [],
      jobgroups: [],
      listPersonnel: [],
      form: {},
      startTime: null,
      endTime: null,
      items: [],
      disabledSelectHome: false,
      loadPersonnel: false,
      loadingInform: false,
      listInform: [],
      informId: props.informId,
      projectId: props.projectId,
      homeId: props.homeId,
      paginationInform: {
        totalCount: 0,
        currentPage: 1,
        perPage: 50,
      },
      informSelected: {},
      visibleModalInform: false,
    }

    this.formRef = React.createRef()
  }

  async showMessageSuccess(msg, duration = 5) {
    return await message.success(msg, duration)
  }

  /**
   * ข้อมูลสถานะใบแจ้งหนี้
   */
  getJobStatus = () => {
    JobService.getJobStatus().then((rs) => {
      if (rs) {
        const data = rs.data['data']
        this.setState({ listJobStatus: data })
      }
    })
  }
  /**
   * หมวดหมู่งานแจ้งซ่อม
   */

  getJobGroup = () => {
    this.setState({ jobgroups: [] })
    JobGroupService.groups().then((rs) => {
      let data = []
      if (rs) {
        let data = []
        const items = rs.data['data']
        if (items) {
          items.map((item, index) => {
            data.push({
              value: item.id,
              text: item.name,
            })
          })
        }
        this.setState({ jobgroups: data })
      }
    })
  }
  /**
   * โครงการ
   */

  getProjects = () => {
    this.setState({ projects: [] })
    ProjectService.all().then((rs) => {
      let data = []
      if (rs) {
        const items = rs.data['data']
        if (items) {
          items.map((item, index) => {
            if (
              this.props.projectId != undefined &&
              this.props.projectId == item.id
            ) {
              data.push({
                value: item.id,
                text: item.name,
              })
            }
            if (!this.props.projectId) {
              data.push({
                value: item.id,
                text: item.name,
              })
            }
          })
        }
        this.setState({ projects: data })
      }
    })
  }

  getHomeByProjectId = (projectId) => {
    this.setState({
      disabledSelectHome: true,
      homes: [],
      loadingHome: true,
      home: {},
    })

    ProjectService.getHomesByProject(projectId)
      .then((rs) => {
        if (rs) {
          this.setState({ homes: rs.data['data'], loading: false })
          this.setState({ disabledSelectHome: false, loadingHome: false })
          if (this.state.homes.length > 0) {
            if (this.state.homeId) {
              const home = this.state.homes.filter(
                (item) => item.id == this.state.homeId,
              )
              if (home[0]) {
                this.setState({
                  home: home[0],
                  home_id: home[0].id,
                })
              }
              console.log('home', this.state.homeId, this.state.home)
            }
          }
        }
      })
      .catch((err) => this.setState({ loadingHome: false }))
  }

  handleSubmit = (values) => {
    const jobId = this.props.jobId
    this.setState({ loading: true })
    if (this.props.informId) {
      values.inform_fix_id = this.props.informId
    }
    if (values) {
      // ปรับ timezone ให้ตรงหลัง submit form เนืองจาก เวลามันไม่ตรง
      values.start_time =
        values.start_time && Moment(values.start_time).isValid()
          ? Moment(values.start_time).utc(7)
          : null
      values.end_time =
        values.end_time && Moment(values.start_time).isValid()
          ? Moment(values.end_time).utc(7)
          : null

      console.log('submit', values)

      JobService.create(values)
        .then((rs) => {
          if (rs) {
            let msg = rs.data['message']
            const data = rs.data.data
            this.setState({
              loading: false,
            })
            this.resetForm()
            openNotificationWithIcon('success', msg)
            this.props.informStore.setJob(data)
            this.props.onCreated(data)
          }
        })
        .catch((err) => {
          this.setState({
            loading: false,
          })
          if (err.response) {
            this.setState({
              loading: false,
            })
          }
        })
    }
  }
  onSubmit = () => {
    this.formRef.current.submit()
  }

  componentWillMount() {
    this.getProjects()
    this.getJobStatus()
    this.getTechnicians()
    this.getJobGroup()
    this.getPersonnel()
  }

  componentDidMount() {
    if (this.props.projectId !== undefined) {
      this.getHomeByProjectId(this.props.projectId)
    }
    if (this.props.projectId) {
      this.formRef.current.setFieldsValue({
        project_id: this.props.projectId,
      })
    }
    if (this.props.homeId) {
      this.formRef.current.setFieldsValue({
        home_id: this.props.homeId,
      })
    }

    if (this.props.informId) {
      this.formRef.current.inform_fix_id = this.props.informId
    }
  }

  resetForm = () => {
    this.formRef.current.resetFields()
  }

  /**
   *  ข้อมูลพนักงาน
   */
  getPersonnel(params) {
    PersonnelService.search(params)
      .then((rs) => {
        if (rs) {
          let data = []
          const items = rs.data.items
          if (items) {
            items.map((item, index) => {
              data.push({
                value: item.user_id,
                text: item.fullnameTH,
              })
            })
          }
          this.setState({ listPersonnel: data })
        }
      })
      .catch((err) => {})
  }
  onSearchPersonnel = (event) => {
    if (event && event.length >= 2) {
      this.setState({
        loadPersonnel: true,
      })
      setTimeout(() => {
        this.getPersonnel({ q: event })
        this.setState({
          loadPersonnel: false,
        })
      }, 1000)
    }
  }

  onSelectPersonnel = (value) => {
    if (value) {
      this.state.listPersonnel.map((item) => {
        if (Number(item.value) == Number(value)) {
          this.formRef.current.setFieldsValue({
            responsible_id: item.value,
            responsible_name: item.text,
          })
        }
      })
    }
  }

  onDeselectPersonnel = (value) => {
    this.formRef.current.setFieldsValue({
      responsible_id: null,
    })
  }

  /**
   *  ใบแจ้งซ่อม
   */
  getInform(params) {
    this.setState({
      loadInform: true,
      listInform: [],
    })
    const _params = {
      ...params,
      project_id: this.state.projectId,
      page: this.state.paginationInform.currentPage,
      'per-page': this.state.paginationInform.perPage,
    }
    InformfixService.search(_params)
      .then((rs) => {
        if (rs.data._meta !== undefined) {
          this.setState({
            paginationInform: rs.data._meta,
          })
        }
        if (rs) {
          let data = []

          const items = rs.data.items
          if (items) {
            data = items
            // items.map((item, index) => {
            //   data.push({
            //     value: item.id,
            //     text: item.code,
            //     date: item.date_inform_string,
            //     description: item.description,
            //     date_inform_string: item.date_inform_string,
            //     home_id: item.home_id,
            //     project_id: item.project_id,
            //     project_name: item.project.name,
            //     home: item.home ? item.home : {},
            //     work_status: item.work_status,
            //     work_status_name: item.workStatusName,
            //     project: item.project,
            //   })
            // })
          }
          this.setState({
            listInform: data,
            loadInform: false,
          })
        }
      })
      .catch((err) => {
        this.setState({
          loadInform: false,
        })
      })
  }

  onSearchInform = (e) => {
    console.log(e.target.value)
    const value = e.target.value
    if (value && value.length >= 2) {
      this.setState({
        loadInform: true,
      })
      setTimeout(() => {
        this.getInform({ q: value, 'per-page': 50 })
        this.setState({
          listInform: [],
          loadInform: false,
        })
      }, 1000)
      return false
    }
    if (!value) {
      setTimeout(() => {
        this.getInform({ q: value, 'per-page': 50 })
        this.setState({
          listInform: [],
          loadInform: false,
        })
      }, 1000)
    }
  }

  onSelectInform = (value) => {
    if (value) {
      this.state.listInform.map((item) => {
        if (Number(item.value) == Number(value)) {
          this.formRef.current.setFieldsValue({
            inform_fix_id: item.value,
            project_id: item.project_id,
            project_name: item.project_name,
            home_id: item.home_id,
          })
          this.setState({
            homeId: item.home_id,
            projectId: item.project_id,
            informId: item.value,
            visibleModalInform: false,
          })

          setTimeout(() => {
            this.getHomeByProjectId(item.project_id)
          }, 200)
        }
      })
    }
  }

  onChangeInform = (value) => {
    if (!value) {
      this.getInform({
        q: '',
        'per-page': 100,
        project_id: this.state.project_id,
      })
      this.formRef.current.setFieldsValue({
        inform_fix_id: null,
        project_id: null,
        project_name: null,
        home_id: null,
      })
      this.setState({
        homeId: null,
        projectId: null,
        informId: null,
      })
    }
  }

  showModalInform = () => {
    this.getInform()
    this.setState({ visibleModalInform: true })
  }
  onChangeResponsible = (value) => {
    let responsibleName = ''
    const user = this.state.techniciansTemp.map((item, index) => {
      if (item.id == value) {
        responsibleName = `${item.firstname} ${item.lastname}`
        console.log(responsibleName)
        this.formRef.current.setFieldsValue({
          responsible_name: responsibleName,
        })
      }
    })
  }

  onSelectJobstatus = (value) => {
    console.log('onSelectJobstatus', value)
    this.formRef.current.setFieldsValue({
      job_status: value,
    })
  }

  getTechnicians() {
    TechnicainService.all()
      .then((rs) => {
        if (rs) {
          let data = []
          const items = rs.data.data
          if (items) {
            items.map((item, index) => {
              data.push({
                value: item.id,
                text:
                  item.firstname +
                  ' ' +
                  item.lastname +
                  (item.technician_type
                    ? ' (' + item.technicianTypeName + ')'
                    : null),
              })
            })
          }
          this.setState({ technicians: data, techniciansTemp: items })
        }
      })
      .catch((err) => {})
  }

  onSelectHome = (value) => {
    const { form } = this.props
    this.state.homes.map((home, index) => {
      if (home.id === value) {
        console.log(home.id, value)
        this.setState({
          home: home,
        })
        const name = this.state.homes[index].customer_name
        this.formRef.current.setFieldsValue({ home_id: home.id })
        this.formRef.current.setFieldsValue({ customer_name: name })
        console.log(this.state.home)
      }
    })
  }
  onChangeProject = (value) => {
    this.formRef.current.setFieldsValue({
      home_id: '',
      inform_fix_id: '',
    })
    this.setState({
      projectId: value,
      homes: [],
      home: {},
      informSelected: {},
      homeId: '',
      informId: '',
    })
    if (value) {
      this.setState({
        homes: [],
        disabledSelectHome: true,
        visibleModalInform: false,
      })
      this.getHomeByProjectId(value)
      this.getInform({ 'per-page': 50, project_id: value })
    }
  }

  render() {
    const {
      listJobStatus,
      technicians,
      techniciansTemp,
      selectedResponsible,
      selectedTechnician,
      listPersonnel,
      listInform,
      home,
      informId,
      homeId,
      projectId,
    } = this.state

    // const { job } = this.props

    const formLayout = 'horizontal'
    const formItemLayout =
      formLayout === 'horizontal'
        ? {
            labelCol: {
              xs: { span: 24 },
              sm: { span: 8 },
              md: { span: 6 },
            },
            wrapperCol: {
              xs: { span: 24 },
              sm: { span: 16 },
              md: { span: 18 },
            },
          }
        : null
    const buttonItemLayout =
      formLayout === 'horizontal'
        ? {
            wrapperCol: {
              xs: { span: 24, offset: 0 },
              sm: { span: 16, offset: 8 },
              md: { span: 18, offset: 4 },
              xl: { span: 18, offset: 4 },
            },
          }
        : null

    // แสดงวันที่
    const showFormatDate = (datetime) => {
      let date = Moment(datetime)
      if (date.isValid()) {
        return date.format('ll')
      } else {
        return null
      }
    }

    const listProjectItems = this.state.projects.map((item, index) => (
      <Option key={index} value={item.value}>
        {item.text}
      </Option>
    ))
    const listHomeItems = this.state.homes.map((item, index) => (
      <Option key={item.id} value={item.id}>
        {(item.homeType ? item.homeType.name : '') +
          (item.plan_no ? ' แปลง ' + item.plan_no : '') +
          (item.home_no ? ' (เลขที่ ' + item.home_no + ')' : '')}
      </Option>
    ))

    const filteredOptionsResponsible = technicians.filter(
      (o) => !selectedResponsible.includes(o),
    )
    const filteredOptionsTechnician = technicians.filter(
      (o) => !selectedTechnician.includes(o),
    )

    // rowSelection object indicates the need for row selection
    const rowSelection = {
      onChange: (selectedRowKeys, selectedRows) => {
        console.log(
          `selectedRowKeys: ${selectedRowKeys}`,
          'selectedRows: ',
          selectedRows,
        )
        if (selectedRows[0] !== undefined) {
          const row = selectedRows[0]
          this.setState({
            informSelected: row,
          })
          // this.formRef.current.setFieldsValue({
          //   home_id: row.home_id,
          //   project_id: row.project_id,
          //   inform_fix_id: row.id,
          // })
          this.getHomeByProjectId(row.project_id)
        }
      },
      getCheckboxProps: (record) => ({
        disabled: record.name === 'Disabled User',
        // Column configuration not to be checked
        name: record.name,
      }),
    }

    return (
      <Fragment>
        <Modal
          open={this.state.visibleModalInform}
          onCancel={() => this.setState({ visibleModalInform: false })}
          title="ใบแจ้งซ่อม"
          onOk={() => {
            const inform = this.state.informSelected
            this.setState({
              visibleModalInform: false,
              informId: inform.id,
            })
            if (inform && inform.home_id) {
              this.setState({
                homeId: inform.home_id,
              })
              this.formRef.current.setFieldsValue({
                home_id: inform.home_id,
              })
            }
            this.formRef.current.setFieldsValue({
              inform_fix_id: this.state.informSelected.id,
            })
          }}
        >
          <Input
            placeholder="เลขที่, บ้านเลขที่, แปลง, ข้อความ"
            onKeyUp={this.onSearchInform}
          />
          <Table
            key={'tableInform'}
            rowKey={(r) => r.id}
            pagination={false}
            size="small"
            columns={[
              {
                title: 'Code',
                dataIndex: 'code',
                key: 'code',
                width: '100px',
                fixed: true,
              },
              {
                title: 'description',
                dataIndex: 'description',
                key: 'description',
                llipsis: true,
                // width: '20%',
                render: (text, row) => (
                  <>
                    <a>{text}</a>
                    <small>
                      <div>
                        <span style={{ color: '#c0c0c0' }}>
                          {row.date_inform_string}
                        </span>
                        <InformfixStatus
                          name={row.workStatusName}
                          statusId={row.work_status}
                        />
                      </div>
                      <div>
                        <span style={{ color: 'red' }}>{row.project.name}</span>
                        {row.home
                          ? `
                            เลขที่ ${row.home.home_no}
                            แปลง ${row.home.plan_no}
                            `
                          : ''}
                      </div>
                    </small>
                  </>
                ),
              },
            ]}
            dataSource={this.state.listInform}
            scroll={{
              x: 2000,
              y: 200,
            }}
            bordered
            rowSelection={{
              type: 'radio',
              ...rowSelection,
            }}
          />
          <Pagination
            size="small"
            pageSize={this.state.paginationInform.perPage}
            current={this.state.paginationInform.currentPage}
            total={this.state.paginationInform.totalCount}
            onChange={(page, limit, filter) => {
              let p = this.state.paginationInform
              p.currentPage = page
              p.perPage = limit
              this.setState({
                paginationInform: p,
              })
              this.getInform()
            }}
            style={{ bottom: '0px' }}
          />
        </Modal>

        <Modal
          open={this.props.visible}
          onCancel={() => this.props.onCancel()}
          title="เพิ่มคิวงานใหม่"
          style={{
            width: (80 * window.innerWidth) / 100,
            minWidth: (80 * window.innerWidth) / 100,
          }}
          footer={
            <Form.Item {...buttonItemLayout}>
              <Button
                type="primary"
                htmlType="button"
                className="submit"
                onClick={() => this.onSubmit()}
              >
                บันทึก
              </Button>{' '}
              <Button
                type="default"
                htmlType="reset"
                className="submit"
                onClick={() => this.resetForm()}
              >
                รีเซ็ต
              </Button>
            </Form.Item>
          }
        >
          <React.Fragment>
            <Form
              ref={this.formRef}
              onFinish={this.handleSubmit}
              style={{ display: 'block' }}
              initialValues={{
                inform_fix_id: this.state.informId || '',
                project_id: this.state.projectId ? this.state.projectId : '',
                home_id: this.state.homeId ? this.state.homeId : '',
              }}
              footer=""
            >
              <Row>
                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }}>
                  <>
                    <Form.Item
                      label="โครงการ"
                      {...formItemLayout}
                      name="project_id"
                      rules={[{ required: true, message: 'เลือกโครงการ' }]}
                    >
                      <Select
                        placeholder="-เลือกโครงการ-"
                        style={{ width: '100%' }}
                        allowClear
                        onChange={this.onChangeProject}
                        showSearch
                        filterOption={(input, option) =>
                          option.props.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                      >
                        {listProjectItems}
                      </Select>
                    </Form.Item>
                  </>
                  {projectId !== undefined ? (
                    <>
                      <Form.Item
                        label="ใบแจ้งซ่อม"
                        {...formItemLayout}
                        name="inform_fix_id"
                        rules={[{ required: false, message: 'ใบแจ้งซ่อม' }]}
                      >
                        {this.props.informId ? (
                          <>
                            <Input />
                          </>
                        ) : (
                          <>
                            <Input
                              disabled={this.state.disabledSelectHome}
                              value={this.state.informId}
                              addonBefore={
                                this.state.informSelected && homeId
                                  ? this.state.informSelected.code
                                  : null
                              }
                              readOnly
                              onClick={this.showModalInform}
                            />
                          </>
                        )}
                        {/* <Select
                      placeholder="--พิมพ์ค้นหา--"
                      showSearch
                      allowClear
                      disabled={this.state.disabledSelectHome}
                      optionFilterProp="children"
                      onSelect={this.onSelectInform}
                      onChange={this.onChangeInform}
                      onSearch={this.onSearchInform}
       
                    >
                      {listInform.map((d) => (
                        <Option key={d.value} value={d.value}>
                          <div style={{ borderBottom: 'solid 1px #222222' }}>
                            <span
                              style={{
                                marginRight: 5,
                                fontWeight: 'bold',
                                fontSize: 'small',
                              }}
                            >
                              {d.text}{' '}
                            </span>{' '}
                            {d.description}
                            <br />
                            <small>
                              <span style={{ color: 'red' }}>{d.date}</span> |{' '}
                              {d.work_status_name}
                              <br />
                              {d.home
                                ? ` (${d.home.home_no} แปลง ${d.home.plan_no}) `
                                : ''}{' '}
                              <span style={{ color: 'blue' }}>
                                {d.project ? `${d.project.name}` : ''}
                              </span>
                            </small>
                          </div>
                        </Option>
                      ))}
                    </Select> */}
                      </Form.Item>

                      {(!this.state.loadingHome &&
                        !homeId &&
                        this.state.informId) ||
                      Number(homeId) < 1 ? (
                        <>
                          <Form.Item
                            shouldUpdate
                            label="บ้าน"
                            {...formItemLayout}
                            name="home_id"
                            rules={[{ required: false, message: 'เลือกบ้าน' }]}
                          >
                            <Select
                              showSearch
                              allowClear
                              disabled={this.state.disabledSelectHome}
                              placeholder="--เลือกบ้าน--"
                              onChange={this.onSelectHome}
                              filterOption={(input, option) =>
                                option.props.children
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                              }
                            >
                              {this.state.homes ? listHomeItems : null}
                            </Select>
                          </Form.Item>
                        </>
                      ) : (
                        <Form.Item
                          shouldUpdate
                          label="รหัสบ้าน"
                          {...formItemLayout}
                          name="home_id"
                          rules={[{ required: false, message: 'รหัสบ้าน' }]}
                        >
                          <Input type="text" disabled htmltype="text" />
                        </Form.Item>
                      )}

                      {home && homeId ? (
                        <Form.Item {...formItemLayout} label="รายละเอียดบ้าน">
                          <div style={{ padding: 5, fontSize: 12 }}>
                            {home.project ? (
                              <>
                                โครงการ : {home.project.name}
                                <br />
                              </>
                            ) : (
                              ''
                            )}
                            {home ? (
                              <>
                                เลขที่ : {home.home_no}
                                <br />
                                แปลง : {home.plan_no}
                                <br />
                                ลูกค้า : {home.customer_name}
                                <br />
                              </>
                            ) : (
                              ''
                            )}

                            <div>
                              {home.transfer_date
                                ? 'วันที่โอน ' +
                                  showFormatDate(home.transfer_date)
                                : '-'}
                            </div>
                            {home && home.warrantyExpired ? (
                              <>
                                <div>
                                  หมดรับประกัน 1 ปี:{' '}
                                  {showFormatDate(home.warrantyExpired['1y'])}
                                </div>
                                <div>
                                  หมดรับประกันโครงสร้าง (5 ปี):{' '}
                                  {showFormatDate(home.warrantyExpired['5y'])}
                                </div>
                              </>
                            ) : null}
                          </div>
                        </Form.Item>
                      ) : null}
                      <Form.Item
                        {...formItemLayout}
                        label="หมวดหมู่"
                        name="group_id"
                        rules={[
                          {
                            required: true,
                            message: 'เลือกหมวดหมู่ความเสียหารย',
                          },
                        ]}
                      >
                        <Select
                          allowClear
                          placeholder="--เลือกหมวดหมู่--"
                          showSearch
                          optionFilterProp="children"
                          filterOption={(input, option) =>
                            option.children
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                          }
                        >
                          {this.state.jobgroups.map((d) => (
                            <Option key={d.value} value={d.value}>
                              {d.text}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                      <Form.Item
                        label="หัวข้อ"
                        {...formItemLayout}
                        name="title"
                        rules={[{ required: true, message: 'หัวข้อ' }]}
                      >
                        <Input type="text" placeholder="หัวข้อ" />
                      </Form.Item>
                      <Form.Item
                        label="รายละเอียด"
                        {...formItemLayout}
                        name="description"
                        rules={[{ required: true, message: 'รายละเอียด' }]}
                      >
                        <TextArea rows={4} placeholder="รายละเอียด" />
                      </Form.Item>
                      <Form.Item
                        label="ตั้งแต่"
                        {...formItemLayout}
                        name="start_time"
                      >
                        <DatePicker
                          placeholder="ตั้งแต่เวลา"
                          style={{ width: '100%' }}
                          showTime={{
                            defaultValue: Moment('09:00:00', 'HH:mm:ss'),
                            minuteStep: 15,
                          }}
                          showToday
                          format="DD/MM/YYYY HH:mm"
                          disabledTime={disabledDateTime}
                          allowClear={true}
                        />
                      </Form.Item>

                      <Form.Item
                        label="ถึงวันที่"
                        {...formItemLayout}
                        name="end_time"
                      >
                        <DatePicker
                          placeholder="ถึงเวลา"
                          style={{ width: '100%' }}
                          showTime={{
                            defaultValue: Moment('09:00:00', 'HH:mm:ss'),
                            minuteStep: 15,
                          }}
                          showToday
                          format="DD/MM/YYYY HH:mm"
                          disabledTime={disabledDateTime}
                          allowClear={true}
                        />
                      </Form.Item>

                      <Form.Item
                        label="มอบหมายงานให้"
                        {...formItemLayout}
                        rules={[
                          { required: false, message: 'ผู้รับมอบหมายงาน' },
                        ]}
                        name="responsible_name"
                      >
                        <Select
                          placeholder="--พิมพ์ค้นหา--"
                          showSearch
                          allowClear
                          optionFilterProp="children"
                          onSearch={this.onSearchPersonnel}
                          onSelect={this.onSelectPersonnel}
                          onDeselect={this.onDeselectPersonnel}
                          filterOption={(input, option) =>
                            option.props.children
                              .toString()
                              .toLowerCase()
                              .indexOf(input.toString().toLowerCase()) >= 0
                          }
                        >
                          {listPersonnel.map((d) => (
                            <Option key={d.value} value={d.value}>
                              {d.text}{' '}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                      <Form.Item
                        shouldUpdate
                        label="มอบหมายงานให้"
                        {...formItemLayout}
                        required={false}
                        name="responsible_id"
                        rules={[
                          { required: false, message: 'ผู้รับมอบหมายงาน' },
                        ]}
                        noStyle
                      >
                        <Input type="hidden" readOnly htmltype="hidden" />
                      </Form.Item>
                      <Form.Item
                        label="ช่างที่ไปด้วย"
                        {...formItemLayout}
                        name="technicians"
                      >
                        <Select
                          mode="multiple"
                          placeholder="--เลือกช่าง--"
                          showSearch
                          allowClear
                          filterOption={(input, option) =>
                            option.props.children
                              .toString()
                              .toLowerCase()
                              .indexOf(input.toString().toLowerCase()) >= 0
                          }
                        >
                          {filteredOptionsTechnician.map((d) => (
                            <Option key={d.value} value={d.value}>
                              {d.text}{' '}
                              {d.technician_type
                                ? '(' + d.technicianTypeName + ')'
                                : null}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                      <Form.Item
                        label="ช่าง/ผู้รับเหมา (อื่น ๆ)"
                        {...formItemLayout}
                        name="technician_name_other"
                        rules={[
                          {
                            required: false,
                            message: 'ช่าง/ผู้รับเหมา (อื่น ๆ)',
                          },
                        ]}
                      >
                        <Input
                          type="text"
                          placeholder="ช่าง/ผู้รับเหมา (อื่น ๆ)"
                        />
                      </Form.Item>
                    </>
                  ) : (
                    ''
                  )}

                  {/* <Form.Item
                    label="สถานะ"
                    {...formItemLayout}
                    rules={[{ required: true, message: 'สถานะคิวงาน' }]}
                    name="job_status"
                  >
                    <Select
                      placeholder="-เลือกสถานะ-"
                      style={{ width: '100%' }}
                      allowClear
                      onSelect={this.onSelectJobstatus}
                    >
                      {listJobStatus
                        ? listJobStatus.map((status, key) => (
                            <Option key={key} value={status.value}>
                              {status.text}
                            </Option>
                          ))
                        : null}
                    </Select>
                  </Form.Item> */}
                </Col>
                <Col
                  xs={{ span: 24 }}
                  sm={{ span: 24 }}
                  md={{ span: 24 }}
                ></Col>
              </Row>
            </Form>
          </React.Fragment>
        </Modal>
        <Modal open={this.state.visibleInform}></Modal>
      </Fragment>
    )
  }
}

export default JobForm
